import { render, staticRenderFns } from "./template.html?vue&type=template&id=324a602c&scoped=true&external"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=324a602c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324a602c",
  null
  
)

export default component.exports